export default content => ({
  template: content.template,
  isLabel: content.isLabel,
  title: content.title,
  text: content.text
});
